import React from 'react';
import { MapPinIcon, UserRoundIcon, ScaleIcon, MessageCircleIcon, HomeIcon, UsersIcon, CheckIcon } from 'lucide-react';
import { Section, SectionHeading } from './shared';
// 13 — WHY SEPAROVIC · [Branding] [Trust]
// Demonstrate difference through evidence. No "better than other firms".
const differentiators = [{
  icon: MapPinIcon,
  title: 'Established since 1990',
  body: 'One of Perth’s oldest and most established plaintiff injury firms, in our Highgate heritage office since 1993.'
}, {
  icon: UserRoundIcon,
  title: 'Personal attention',
  body: 'You work with a named legal team who know your claim — not a call centre.'
}, {
  icon: ScaleIcon,
  title: 'Specialist injury focus',
  body: 'We represent injured people exclusively. It is all we do, and we are known as tough, sharp negotiators.'
}, {
  icon: MessageCircleIcon,
  title: 'Plain-English explanations',
  body: 'We explain your options clearly, without legal jargon, so you always know where things stand.'
}, {
  icon: HomeIcon,
  title: 'Home & hospital appointments',
  body: 'If you cannot leave home or hospital, we arrange a discreet, confidential visit to you.'
}, {
  icon: UsersIcon,
  title: 'We help rebuild lives',
  body: 'We do not just manage claims — we support you toward a successful result, fair compensation and hope for the future.'
}];
const expectations = ['Clear communication', 'Explained fees', 'Documented strategy', 'Realistic advice', 'Direct contact', 'Progress updates'];
export function WhySeparovic() {
  return <Section data-id="element-613">
      <SectionHeading eyebrow="Why Separovic" title="Why Injured Western Australians Choose Separovic" data-id="element-614" />

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-615">
        {differentiators.map(d => {
        const Icon = d.icon;
        return <div key={d.title} className="rounded-card border border-ink/5 bg-paper p-7 shadow-card transition-transform duration-200 hover:-translate-y-0.5" data-id="element-616">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-btn bg-forest/8 text-forest" data-id="element-617">
                <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.75} data-id="element-618" />
              </span>
              <h3 className="mt-4 text-h4 font-semibold text-ink" data-id="element-619">{d.title}</h3>
              <p className="mt-2 text-body text-slate" data-id="element-620">{d.body}</p>
            </div>;
      })}
      </div>

      {/* Restrained expectation block */}
      <div className="mt-8 rounded-card bg-forest p-7 shadow-card-lg md:p-9" data-id="element-621">
        <h3 className="text-h4 font-semibold text-paper" data-id="element-622">
          What clients should expect from an injury-law firm
        </h3>
        <ul className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-623">
          {expectations.map(e => <li key={e} className="flex items-center gap-2.5 text-body text-paper/90" data-id="element-624">
              <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-gold/20 text-gold" data-id="element-625">
                <CheckIcon aria-hidden="true" className="h-3.5 w-3.5" strokeWidth={2.25} data-id="element-626" />
              </span>
              {e}
            </li>)}
        </ul>
      </div>
    </Section>;
}